import { render } from "./HomePageNine.vue?vue&type=template&id=e28c4b9a&scoped=true"
import script from "./HomePageNine.vue?vue&type=script&lang=js"
export * from "./HomePageNine.vue?vue&type=script&lang=js"

import "./HomePageNine.vue?vue&type=style&index=0&id=e28c4b9a&lang=scss&scoped=true"

import exportComponent from "/Users/leonardoprado/Documents/My Projects/Natalia/nuron-nft-vue-js-template-2024-03-07-14-00-41-utc/nuron-vuejs/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e28c4b9a"]])

export default __exports__